import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

export default function areAttendeeTypeCollectionsEqual(
    originalAttendees: AttendeeType[],
    newAttendees: AttendeeType[]
): boolean {
    const originalCollection = originalAttendees || [];
    const newCollection = newAttendees || [];

    if (originalCollection.length != newCollection.length) {
        return false;
    }

    // Store original attendee smtp in a dictonary for fast look up
    const originalAttendeeSet = new Set<string>();
    originalCollection.forEach(original => {
        const key = getAttendeeTypeKey(original.Mailbox);
        if (key.length > 0) {
            originalAttendeeSet.add(key);
        }
        // skip the ones that don't have a valid key as we don't support them
    });

    // Check if attendee is existing in originalAttendeeSet
    for (var newAttendee of newCollection) {
        const newAttendeeKey = getAttendeeTypeKey(newAttendee.Mailbox);
        if (!originalAttendeeSet.has(newAttendeeKey)) {
            return false;
        }
    }

    return true;
}

function getAttendeeTypeKey(mailbox: EmailAddressWrapper): string {
    if (!mailbox) {
        return '';
    }

    // Construct the key for dedupping from email smtp or itemId if it's a private dl, plus routing type
    // https://o365exchange.visualstudio.com/Outlook%20Services/_workitems/edit/1231115
    const routingType = mailbox.RoutingType ? mailbox.RoutingType.toLowerCase() : '';
    const emailAddress = mailbox.EmailAddress ? mailbox.EmailAddress.toLowerCase() : null;
    const itemId = mailbox.ItemId?.Id ? mailbox.ItemId.Id : '';
    return (routingType + ':' + (emailAddress || itemId)).trim();
}
